import { createContext, JSX } from "react"

export type PaginationContextType = {
    recordsPerPage: number
    recordsPerPageList: number[]
}

interface propsInterface {
    children: JSX.Element
}

const defaultPaginationData = {
    recordsPerPage: 16,
    recordsPerPageList: [ 8, 16, 32 ]
}

export const Context = createContext<PaginationContextType>(defaultPaginationData)

export default function PaginationContext(props: propsInterface) {
    const { children } = props

    return (
        <Context.Provider value={ defaultPaginationData }>
            { children }
        </Context.Provider>
    )
}